import { c as _c } from "react/compiler-runtime";
import { useMemo, useRef, useState } from 'react';
import { getBarWidth, getMetricValue, parseAnalyticsToSeriesBreakDownChart, setBorderRadiusForSeries } from '@/modules/finances/lib/breakdown-chart-utils';
import { useMediaQuery } from '@/modules/shared/hooks/use-media-query';
import type { BreakdownBudgetAnalytic, Budget, GRANULARITY_OPTIONS, METRIC_OPTIONS } from '../../types';
import type { EChartsOption } from 'echarts-for-react';
interface BreakdownChartProps {
  budgetsAnalytics: BreakdownBudgetAnalytic | undefined;
  budgets: Budget[];
  allBudgets: Budget[];
  year: string;
  codePath: string;
  granularity: GRANULARITY_OPTIONS;
  metric: METRIC_OPTIONS;
}
export function useBreakdownChart(t0) {
  const $ = _c(46);
  const {
    budgetsAnalytics,
    budgets,
    allBudgets,
    codePath,
    granularity,
    metric
  } = t0;
  const refBreakDownChart = useRef(null);
  const selectedGranularity = granularity;
  const [isChecked, setIsChecked] = useState(true);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      to: "sm"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isMobile = useMediaQuery(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      from: "sm",
      to: "lg"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isTablet = useMediaQuery(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      from: "lg",
      to: "xl"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const isDesktop1024 = useMediaQuery(t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      from: "xl",
      to: "2xl"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const isDesktop1280 = useMediaQuery(t4);
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      from: "2xl"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const isDesktop1536Plus = useMediaQuery(t5);
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [];
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const [inactiveSeries, setInactiveSeries] = useState(t6);
  let t7;
  if ($[6] !== codePath) {
    t7 = codePath.split("/");
    $[6] = codePath;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const levelNumber = t7.length;
  const barBorderRadius = isMobile ? 2 : 4;
  const t8 = isDesktop1280 || isDesktop1536Plus;
  let t9;
  if ($[8] !== isDesktop1024 || $[9] !== isMobile || $[10] !== isTablet || $[11] !== selectedGranularity || $[12] !== t8) {
    t9 = getBarWidth(isMobile, isTablet, isDesktop1024, t8, selectedGranularity);
    $[8] = isDesktop1024;
    $[9] = isMobile;
    $[10] = isTablet;
    $[11] = selectedGranularity;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const barWidth = t9;
  let t10;
  if ($[14] !== metric) {
    t10 = getMetricValue(metric);
    $[14] = metric;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const getMetric = t10;
  let t11;
  if ($[16] !== allBudgets || $[17] !== barBorderRadius || $[18] !== barWidth || $[19] !== budgets || $[20] !== budgetsAnalytics || $[21] !== getMetric) {
    const seriesWithoutBorder = parseAnalyticsToSeriesBreakDownChart(budgetsAnalytics, budgets, barWidth, getMetric, allBudgets);
    const series = setBorderRadiusForSeries(seriesWithoutBorder, barBorderRadius);
    t11 = series.sort(_temp3);
    $[16] = allBudgets;
    $[17] = barBorderRadius;
    $[18] = barWidth;
    $[19] = budgets;
    $[20] = budgetsAnalytics;
    $[21] = getMetric;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const allSeries = t11;
  let t12;
  if ($[23] !== allSeries || $[24] !== barBorderRadius || $[25] !== inactiveSeries) {
    let t13;
    if ($[27] !== inactiveSeries) {
      t13 = item => {
        if (inactiveSeries.includes(item.name)) {
          return {
            ...item,
            isVisible: false,
            itemStyle: {
              ...item.itemStyle,
              colorOriginal: "#ccc"
            },
            data: item.data.map(_temp4)
          };
        }
        return item;
      };
      $[27] = inactiveSeries;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    const parsedSeries = allSeries.map(t13);
    t12 = setBorderRadiusForSeries(parsedSeries, barBorderRadius);
    $[23] = allSeries;
    $[24] = barBorderRadius;
    $[25] = inactiveSeries;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const series_0 = t12;
  let t13;
  if ($[29] !== inactiveSeries) {
    t13 = toggleSeries => {
      setInactiveSeries(inactiveSeries.includes(toggleSeries) ? inactiveSeries.filter(series_1 => series_1 !== toggleSeries) : [...inactiveSeries, toggleSeries]);
    };
    $[29] = inactiveSeries;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const handleToggleSeries = t13;
  let t14;
  if ($[31] !== allSeries || $[32] !== inactiveSeries || $[33] !== isChecked) {
    t14 = () => {
      if (!isChecked && inactiveSeries.length > 0) {
        setInactiveSeries([]);
      } else {
        setInactiveSeries([...allSeries.map(_temp5)]);
      }
      setIsChecked(!isChecked);
    };
    $[31] = allSeries;
    $[32] = inactiveSeries;
    $[33] = isChecked;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const handleChangeSwitch = t14;
  let t15;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = legendName => {
      const chartInstance = refBreakDownChart.current?.getEchartsInstance();
      chartInstance?.dispatchAction({
        type: "highlight",
        seriesName: legendName
      });
    };
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const onLegendItemHover = t15;
  let t16;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = legendName_0 => {
      const chartInstance_0 = refBreakDownChart.current?.getEchartsInstance();
      chartInstance_0?.dispatchAction({
        type: "downplay",
        seriesName: legendName_0
      });
    };
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const onLegendItemLeave = t16;
  const showScrollAndToggle = isMobile ? series_0.length > 6 : series_0.length > 8;
  const showLegendValue = levelNumber <= 2;
  let t17;
  if ($[37] !== getMetric || $[38] !== handleChangeSwitch || $[39] !== handleToggleSeries || $[40] !== isChecked || $[41] !== selectedGranularity || $[42] !== series_0 || $[43] !== showLegendValue || $[44] !== showScrollAndToggle) {
    t17 = {
      series: series_0,
      showScrollAndToggle,
      handleToggleSeries,
      handleChangeSwitch,
      isChecked,
      onLegendItemHover,
      onLegendItemLeave,
      refBreakDownChart,
      showLegendValue,
      selectedGranularity,
      selectedMetric: getMetric
    };
    $[37] = getMetric;
    $[38] = handleChangeSwitch;
    $[39] = handleToggleSeries;
    $[40] = isChecked;
    $[41] = selectedGranularity;
    $[42] = series_0;
    $[43] = showLegendValue;
    $[44] = showScrollAndToggle;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
}
function _temp5(series_2) {
  return series_2.name;
}
function _temp4() {
  return {
    value: 0,
    itemStyle: {
      borderRadius: [0, 0, 0, 0]
    }
  };
}
function _temp3(a, b) {
  const sumA = a.data.reduce(_temp, 0);
  const sumB = b.data.reduce(_temp2, 0);
  return sumB - sumA;
}
function _temp2(acc_0, cur_0) {
  return acc_0 + (cur_0.value ?? 0);
}
function _temp(acc, cur) {
  return acc + (cur.value ?? 0);
}